module.exports = __webpack_public_path__ + "img/bored.c32947e3.png";